import { useEffect, useState } from 'react';
import {
  PossibleCompetitorSanction,
  getPossibleCompetitorSanctions,
  peekPossibleCompetitorSanctions,
} from 'services/actions/ai_management_possible_competitors';

export function usePossibleCompetitorSanctions(biddingId: number | null, cnpj: string) {
  const peek = () => (biddingId ? peekPossibleCompetitorSanctions(biddingId, cnpj) : undefined);
  const [sanctions, setSanctions] = useState<PossibleCompetitorSanction[]>(
    () => peek()?.data.penalidades ?? [],
  );
  const [loading, setLoading] = useState(() => !peek());
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!biddingId) {
      setLoading(false);
      setError(true);
      return undefined;
    }

    const hit = peek();
    if (hit) {
      setSanctions(hit.data.penalidades ?? []);
      setLoading(false);
      setError(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    setError(false);

    getPossibleCompetitorSanctions(biddingId, cnpj)
      .then(({ data }) => {
        if (!active) return;
        setSanctions(data.penalidades ?? []);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setError(true);
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [biddingId, cnpj]);

  return { sanctions, loading, error };
}
